/* eslint-disable @typescript-eslint/no-throw-literal */
import { redirect, type LoaderFunctionArgs } from 'react-router-dom';

const normalizePath = (p: string) => (p.startsWith('/') ? p : `/${p}`);
const stripTrailingSlash = (p: string) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

const stripKnownContext = (pathname: string) => {
	const p = stripTrailingSlash(normalizePath(pathname || '/'));

	// Si algún día el contexto cambia, cambia SOLO aquí.
	const CONTEXT = '/colegio-madrid';

	if (p === CONTEXT) return '/';
	if (p.startsWith(`${CONTEXT}/`)) return p.slice(CONTEXT.length) || '/';
	return p;
};

export function conferenciasGateLoader({ request }: LoaderFunctionArgs) {
	const enabled = String(process.env.REACT_APP_RELEASE_GATE_ENABLED).toLowerCase() === 'true';
	if (!enabled) return null;

	const url = new URL(request.url);

	const allowed = stripTrailingSlash(normalizePath(process.env.REACT_APP_RELEASE_GATE_ALLOWED_PATH ?? '/'));

	const current = stripTrailingSlash(stripKnownContext(url.pathname));

	if (current === allowed || current.startsWith(`${allowed}/`)) return null;

	throw redirect(`${allowed}${url.search}`);
}
